import React, { useCallback } from 'react'

import { func, string } from 'prop-types'

import SubscriptionEvents from 'Pods/Shared/Constants/subscriptionEvents'
import useTracker from 'Pods/Shared/Hooks/useTracker'
import I18n from 'Pods/Shared/I18n'

import { NOOP } from 'Utils/stableDefaults'

function GuestBanner({
  email,
  locale = 'en',
  onReset = NOOP,
}) {
  const t = useCallback(
    (key, options = {}) => I18n.t(key, { ns: 'rails', lng: locale, ...options }),
    [locale]
  )

  const { trackEvent } = useTracker()

  function handleReset() {
    trackEvent(SubscriptionEvents.GUEST_NOT_YOU_CLICKED)
    onReset()
  }

  return (
    <div className="guest-banner">
      <span className="cgt-body-medium">
        {t('subscription_checkout.guest_banner.paying_as')}{' '}
        <strong>{email}</strong>
      </span>
      <button
        type="button"
        className="guest-banner__reset-link"
        onClick={handleReset}
      >
        {t('subscription_checkout.guest_banner.not_you')}
      </button>
    </div>
  )
}

GuestBanner.propTypes = {
  email: string.isRequired,
  locale: string,
  onReset: func,
}

export default GuestBanner
